import { render, staticRenderFns } from "./FixedPhraseEditDialog.vue?vue&type=template&id=025b6f3a&scoped=true&"
import script from "./FixedPhraseEditDialog.vue?vue&type=script&lang=ts&"
export * from "./FixedPhraseEditDialog.vue?vue&type=script&lang=ts&"
import style0 from "./FixedPhraseEditDialog.vue?vue&type=style&index=0&id=025b6f3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025b6f3a",
  null
  
)

export default component.exports